import type { TraceProgressCounts } from "../lib/types.ts";

const SEGMENTS: Array<{ key: keyof TraceProgressCounts; label: string; color: string }> = [
	{ key: "expanded", label: "expanded", color: "#16a34a" },
	{ key: "fetching", label: "fetching", color: "#2563eb" },
	{ key: "pending", label: "pending", color: "#94a3b8" },
	{ key: "stopped", label: "stopped", color: "#d97706" },
	{ key: "error", label: "error", color: "#dc2626" },
];

/** Small stacked bar (pending/fetching/expanded/stopped/error) + numbers. */
export function TraceProgress({
	counts,
	compact = false,
}: {
	counts: TraceProgressCounts;
	compact?: boolean;
}) {
	const total = SEGMENTS.reduce((s, seg) => s + (counts[seg.key] ?? 0), 0);
	return (
		<div className={compact ? "min-w-[140px]" : ""}>
			<div className="flex h-1.5 w-full overflow-hidden rounded-pill bg-surface-2">
				{total > 0 &&
					SEGMENTS.map((seg) => {
						const v = counts[seg.key] ?? 0;
						if (!v) return null;
						return (
							<div
								key={seg.key}
								style={{ width: `${(v / total) * 100}%`, background: seg.color }}
								title={`${seg.label}: ${v}`}
							/>
						);
					})}
			</div>
			<div className="mt-1 flex flex-wrap gap-x-2 text-[10px] text-muted">
				{SEGMENTS.map((seg) => (
					<span key={seg.key} className="inline-flex items-center gap-1">
						<span
							className="inline-block h-1.5 w-1.5 rounded-pill"
							style={{ background: seg.color }}
						/>
						{compact ? "" : `${seg.label} `}
						<span className="text-content">{counts[seg.key] ?? 0}</span>
					</span>
				))}
			</div>
		</div>
	);
}

export function jobCounts(j: {
	pending: number;
	fetching: number;
	expanded: number;
	stopped: number;
	errors: number;
}): TraceProgressCounts {
	return {
		pending: j.pending,
		fetching: j.fetching,
		expanded: j.expanded,
		stopped: j.stopped,
		error: j.errors,
	};
}
